import { useEffect, useState } from "react";
import { HostRoute } from "./types";

const errorText =
  "Please fill all the fields in the Host routes, or disable it";
const initialHostRoutes: HostRoute = { destination: "", nexthop: "" };

const validateHostRoutes = (data: HostRoute[]) =>
  data.every((hostRoutes) => hostRoutes.destination && hostRoutes.nexthop);

const useHostRoutesValidation = (
  completeCreate: boolean,
  hostRoutesStatus: boolean,
) => {
  const [hostRoutes, setHostRoutes] = useState<HostRoute[]>([
    initialHostRoutes,
  ]);
  const [hostRoutesError, setHostRoutesError] = useState("");

  useEffect(() => {
    const isValid = validateHostRoutes(hostRoutes);
    if (completeCreate && hostRoutesStatus) {
      setHostRoutesError(isValid ? "" : errorText);
    } else {
      setHostRoutesError("");
    }
  }, [hostRoutes, hostRoutesError, hostRoutesStatus, completeCreate]);

  return { hostRoutes, hostRoutesError, onHostRoutesChange: setHostRoutes };
};
export default useHostRoutesValidation;
